import styled from 'styled-components';

export const AutoScrollContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  background: #00000000;
  height: 100%;
  padding: 12px;
`;
